<template>
  <div>

    <xolas-table
      title="Backhaul"
      icon="fa fa-wifi"

      table-ref="backhaultable"

      :url="'/backhaul/site/' + rowData.id"

      hide-org-badge
      :show-search="false"

      :fields="backhaulFields">

    </xolas-table>

  </div>

</template>

<script>

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import XolasTable from '@/components/atoms/tables/XolasTable'

export default {
  mixins: [DateMixins, NumberMixins],

  components: {
    XolasTable
  },

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },

  methods: {

    formatStatus (value, inclText = false) {
      var icon = ''
      var color = 'darkgrey'

      if (value === 'Completed') {
        color = 'seagreen'
        icon = 'check-square'
      }

      if (value === 'KIV') {
        icon = 'clock'
      }

      if (value === 'Pending Payment') {
        color = 'goldenrod'
        icon = 'credit-card'
      }

      if (value === 'Approved') {
        color = 'seagreen'
        icon = 'thumbs-up'
      }

      if (value === 'Active') {
        color = 'slateblue'
        icon = 'check'
      }

      if (value === 'Terminated') {
        color = 'indianred'
        icon = 'bolt'
      }

      if (value === 'Pending') {
        color = 'goldenrod'
        icon = 'random'
      }

      return '<b><i class="fa fa-' + icon + '" style="color: ' + color + ';">' +
        '&nbsp;</i><span style="color: ' + color + ';">&nbsp;' +
        (this.isMobile ? '' : (inclText ? value : '')) +
        '</span></b>'
    },

    formatProvider (value) {
      if (value) {
        return '<b class="text-success">' + value + '</b>'
      } else {
        return ''
      }
    },

    formatUsers (value) {
      if (value && this.provider) {
        let users = []

        if ((!this.isTowerCo() && !this.isBackhaulCo()) && value.length > 0) {
          users.push(`Total: ${value.length}`)
        }

        for (var i = 0; i < value.length; i++) {

          let name = value[i].organisation.shortName
          let orgId = value[i].organisation.id

          if (this.isMobile) {
            name = name.toUpperCase().substring(0, 1)
          } else {
            name = name.toUpperCase().substring(0, 3)
          }

          if (this.isTowerCo() || this.isBackhaulCo()) {
            users.push(name)
          } else {

            if (this.sharerId === orgId) {
              users.push(name)
            }

          }
        }
        return '<b>' + users + '</b>'

      } else {

        if (value && value.rowData) {
          return '<b>' + value.rowData.sharer.shortName + '</b>'

        } else {
          return ''

        }
      }

    },

    hasThisSharer (id, rowData) {
      return false
    }

  },


  data () {
    return {
      // Per-column min-widths in the legacy vuetable's content ratios so el-table
      // flexes them to fill instead of distributing every column equally (which
      // wrapped Site Id and inflated row height). Sum stays under the table width
      // so the columns fill without a horizontal scrollbar — XOL-231.
      backhaulFields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id',
          minWidth: '45'
        },
        {
          name: 'site.siteId',
          title: 'Site Id',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          visible: !this.siteId,
          minWidth: '150'
        },
        {
          name: 'status',
          title: 'Status',
          callback: this.formatStatus,
          minWidth: '70'
        },
        {
          name: 'provider.shortName',
          title: 'Provider',
          callback: this.formatProvider,
          minWidth: '85'
        },
        {
          name: 'backhaulType',
          title: 'Type',
          minWidth: '125'
        },
        {
          name: 'active',
          title: 'Customers',
          callback: this.formatUsers,
          minWidth: '90'
        },
        {
          name: 'depositFee',
          title: 'Entrance',
          sortField: 'depositFee',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          callback: this.formatNumber,
          visible: this.canAccess('finance'),
          minWidth: '85'
        },
        {
          name: 'rightOfWayCharges',
          title: 'RoW',
          sortField: 'rightOfWayCharges',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          callback: this.formatNumber,
          visible: this.canAccess('finance'),
          minWidth: '80'
        },
        {
          name: 'started',
          title: 'Started',
          sortField: 'tenor',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          callback: this.formatDate,
          minWidth: '100'
        },
        {
          name: 'expiry',
          title: 'Expiry',
          titleClass: 'text-danger',
          dataClass: 'text-danger',
          callback: this.formatDate,
          minWidth: '100'
        }
      ]
    }
  }
}
</script>
